<template>
    <v-container max-width="100%" style="margin-top: 2%">

    <template>
      <v-row justify="center">
        <v-dialog v-model="progressoDialog" persistent max-width="500" style="height: 300px; z-index: 90000">
          <v-card>
            <v-card-text>
              <v-row justify="center">
                <h3 style="margin-top: 20px; color: #1565c0">
                  {{ this.mensagemProgressoDialog }}
                </h3>
              </v-row>

              <v-row justify="center">
                <v-progress-circular :size="50" :width="5" color="primary" indeterminate
                  style="margin-top: 10px; margin-bottom: 10px"></v-progress-circular>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <v-dialog v-model="confirmResetDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">
          <span style="color: #d60000">{{ $t('system.alert') }}</span>
        </v-card-title>
        <v-card-text>
          <span style="color: #d60000">{{ this.mensagemResetDialog }}</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-4" class="white--text"
            @click="confirmResetDialog = false">{{ $t('button.cancel') }}</v-btn>
          <v-btn color="red accent-4" class="white--text" @click="resetNotificacao()">{{ $t('button.confirmOk') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container class="toolbar__container">
      <v-form ref="formNotificacoValidado">
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <LazySelect
              ref="empresaSelect"
              get-url="getEmpresaslazy"
              text="razao_social"
              value="id_empresa"
              :label="$tc('company.self', 1)"
              @input="onEmpresaInput"
            />
          </v-col>
          <!-- adicionar unidade -->
          <v-col cols="12" sm="6" md="3">
            <MultiplaEscolha
              ref="unidadesSelect"
              lazy
              get-url="getUnidadeslazy"
              :items="semUnidadeOption"
              v-bind:selected-items.sync="unidadesSelecionadas"
              text="descricao_unidade"
              value="id_unidade"
              :label="$t('nav.registration.units')"
              :max-items="2"
            />
          </v-col>
          <!-- termina unidade -->
          <v-col cols="12" sm="6" md="2">
            <LazySelect
              ref="linhaSelect"
              get-url="getLinhaslazy"
              text="nome_linha"
              value="id_linha"
              :label="$tc('line.self', 1)"
              @input="idLinhaSelected = $event"
            />
          </v-col>
          <v-col cols="12" sm="6" md="2">
            <MultiplaEscolha
              ref="veiculosSelect"
              lazy
              get-url="getVeiculoslazy"
              v-bind:selected-items.sync="idVeiculosSelected"
              text="numero_ordem"
              value="id_veiculo"
              :label="$tc('vehicle.self', 1)"
              :max-items="2"
            />
          </v-col>

          <v-col cols="12" sm="6" md="3">
            <v-autocomplete v-model="idTipoNotificacaoSelected" :items="tipoNotificacaoSelect"
              item-text="descricao_tipo_notificacao" item-value="id_tipo_notificacao" clearable multiple
              :label="$t('operation.notificationHeaders.type')"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="2">
            <v-autocomplete v-model="tratadaSelected" :items="itensSelectTratada" item-text="descricao" item-value="id"
              clearable :label="$t('operation.notificationHeaders.treated')"></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>

          <v-col align="right" cols="12" sm="6" md="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaNotificacoes">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="limparFiltrosNotificacoes" style="margin-left: 10px">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.newConsult') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="showResetNotificacaoDialog(null)" style="margin-left: 10px">
                  <v-icon>mdi-checkbox-marked-circle</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('relNotification.resetPeriod') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-alert dismissible type="error" dense center max-width="100%" v-model="showAlertErroNotificacoes"
      style="margin-bottom: 20px; border-radius: 10px; z-index: 20000">
      {{ this.mensagemAlertaErro }}
    </v-alert>

    <v-alert dismissible type="success" dense center max-width="100%" v-model="showAlertSucessoNotificacoes"
      style="margin-bottom: 20px; border-radius: 10px; z-index: 20000">
      {{ this.mensagemAlertaSucessoNotificacao }}
    </v-alert>

    <div id="tablecontainer">
      <v-data-table :headers="headers" :items="filteredNotificacoes" :search="search" :loading="loading"
        :loading-text="$t('system.messages.loading')" sort-by="hierarquia_notificacao"
        :sort-desc="[false, true]" dense class="elevation-7" locale="pt"
        style="border-radius: 10px; margin-top: 10px" :options="{ itemsPerPage: 10 }">
        <template v-slot:top>
          <v-toolbar flat color="white" style="border-radius: 10px">
            <v-toolbar-title>
              <h2 class="headline" style="color: #4a4a4a">{{ $t('relNotification.relNotification') }}</h2>
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('system.search')" single-line
              hide-details></v-text-field>
            <v-spacer></v-spacer>

            <vue-json-to-csv :json-data="filteredNotificacoes" :csv-title="$t('relNotification.relNotification')"
              separator=";" @success="sucessoExportCsv" @error="sucessoExportCsv">
              <v-tooltip top style="z-index: 8000;">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab @click="exportNotificacoesCsv">
                    <v-icon>mdi-export-variant</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('system.labels.exportToCsv') }}</span>
              </v-tooltip>
            </vue-json-to-csv>

            <ExportTablePdf :title="$t('relNotification.relNotification')" :content="filteredNotificacoes"
              :headers="headers" filename="notificacoes"></ExportTablePdf>

          </v-toolbar>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-icon :disabled="item.reset == 0 ? false : true" class="mr-2" color="blue"
            @click="showResetNotificacaoDialog(item)">mdi-checkbox-marked-circle</v-icon>
          <v-icon class="mr-2" color="green" @click="showDialogMapaNotificacoes(item)">mdi-map-marker</v-icon>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialogMapa" fullscreen max-width="100%" style="z-index: 80000; background-color: white">
      <MapaNotificacao :item-mapa-notificacao="itemMapaNotificacao[0]" :lat-notificacao="latNotificacao"
        :lng-notificacao="lngNotificacao" :dt-posicao-notificacao="dtPosicaoNotificacao"
        :item-endereco-import="itemEndereco[0]" :user="user" :token="token" :bilhetagens="bilhetagens" :key="key"
        :has_validador="showInfoValidador" @close="closeDialogMapaNotificacoes"></MapaNotificacao>
    </v-dialog>
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import jsPDF from "jspdf";
import domtoimage from "dom-to-image";
import DateUtils from "../utils/dateutils";
import MapaNotificacao from "./MapaNotificacao.vue";
import EventBus from "@/utils/eventBus";
import VueJsonToCsv from 'vue-json-to-csv';
import ExportTablePdf from './ExportTablePdf.vue';
import translateDbField from "@/utils/translateDbField";
import { buildTabelaFrontHeaders } from "@/utils/tabelasFrontHeaders";
import MultiplaEscolha from './Selects/MultiplaEscolha.vue';
import LazySelect from './Selects/LazySelect.vue';

export default {
  components: {
    MapaNotificacao,
    VueJsonToCsv,
    ExportTablePdf,
    MultiplaEscolha,
    LazySelect,
  },
  data: () => ({
    headers: [],
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    autorizacaoDialog: false,
    mensagemAutorizacaoDialog: "",
    showAlertErroNotificacoes: false,
    mensagemAlertaErro: "",
    showAlertSucessoNotificacoes: false,
    mensagemAlertaSucessoNotificacao: "",
    progressoDialog: false,
    mensagemProgressoDialog: "",
    confirmResetDialog: false,
    mensagemResetDialog: "",
    idnotificacaoreset: null,
    dialogMapa: false,
    togleBtnObterEndereco: false,
    showProgressoEndereco: false,
    zoom: 12,
    minZoom: 5,
    maxZoom: 18,
    center: null,
    currentCenter: null,
    currentZoom: 12,
    mapOptions: {
      zoomSnap: 0.5,
    },
    latNotificacao: null,
    lngNotificacao: null,
    dtPosicaoNotificacao: null,
    idVeiculoNotificacao: null,
    bilhetagens: [],
    itemMapaNotificacao: [
      {
        id_notificacao: "",
        dt_notificacao: "",
        dt_notificacao_extenso: "",
        id_tipo_notificacao: "",
        descricao_tipo_notificacao: "",
        id_veiculo: "",
        nome_linha_veiculo: "",
        cod_veiculo: "",
        nome_permissionario: "",
        cod_equipamento: "",
        nome_area_veiculo: "",
        id_empresa: "",
        id_area: "",
        tem_area: "",
        nome_area: "",
        shape_area: "",
        id_cerca: "",
        tem_cerca: "",
        nome_cerca: "",
        shape_cerca: "",
        id_linha: "",
        tem_linha: "",
        nome_linha: "",
        velocidade_linha: "",
        shape_linha: "",
        lat: "",
        lng: "",
        rumo: "",
        velocidade: "",
        reset: "",
        reset_extenso: "",
      }],
    itemEndereco: [
      {
        street: "",
        houseNumber: "",
        district: "",
        city: "",
        stateCode: "",
        postalCode: "",
      }],
    polylineNotificacoes: {
      latlngs: [],
      color: "red",
    },
    polygonNotificacoes: {
      latlngs: [],
      color: "blue",
    },
    markerBilhetagensVisible: false,
    showPolygonNotificacao: false,
    showPolylineNotificacao: false,
    apikey: "FOvzDukk0SIaGv8RRFW50DQypjKr9HgD7hsV-S3NXFg",
    platform: null,
    user: null,
    token: null,
    config: null,
    loading: false,
    search: "",
    posicoes: [],
    unidadesSelecionadas: [],
    dti: null,
    dtf: null,
    dtiMapa: null,
    dtfMapa: null,
    idEmpresaSelected: null,
    idVeiculosSelected: [],
    idTipoNotificacaoSelected: null,
    tipoNotificacaoSelect: [],
    tratadaSelected: null,
    timeProps: {
      useSeconds: true,
    },
    formValidado: false,
    key: 0,
    notificacoes: [],
    filteredNotificacoes: [],
    idLinhaSelected: null,
    setup: {
      has_validador: 0,
    }

  }),
  computed: {
    showInfoValidador() {
      return this.setup.has_validador === 1;
    },
    centerDefault() {
      return this.$store.getters['config/centerDefault'];
    },
    semUnidadeOption() {
      return [
        {
          id_unidade: -1,
          descricao_unidade: 'Sem Unidade',
          cod_unidade: 'SU',
        },
      ];
    },
    itensSelectTratada() {
      return [
        { id: "0", descricao: this.$t('button.dismiss') },
        { id: 1, descricao: this.$t('button.confirm') }]
    },
    textFieldProps() {
      return {
        prependInnerIcon: "mdi-calendar",
        rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
      }
    },
    today() {
      return new Date().toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.today
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min
      }
    }
  },
  watch: {
    '$i18n.locale'() {
      this.initialize();
    },
  },
  created() {
    this.platform = new window.H.service.Platform({
      apikey: this.apikey,
    });
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.currentCenter = this.centerDefault;
    this.initialize();
  },
  methods: {

    idsUnidadesNoObjeto(o) {
      if (Array.isArray(o.unidades) && o.unidades.length) {
        return o.unidades.map((id) => Number(id));
      }
      if (o.id_unidade != null && o.id_unidade !== "") {
        return [Number(o.id_unidade)];
      }
      return [];
    },
    passaFiltroUnidades(o) {
      if (this.unidadesSelecionadas.length === 0) {
        return true;
      }
      const selecionadas = this.unidadesSelecionadas.map((id) => Number(id));
      return this.idsUnidadesNoObjeto(o).some((id) => selecionadas.includes(id));
    },
    initialize() {
      this.getConfig();
      this.getHeaders();
      this.populaTipoNotificacaoSelect();
      this.populaSetup();
    },
    getHeaders() {
      buildTabelaFrontHeaders("RELNOTIFICACOES", this.token, {
        sessionKey: "headers_RELNOTIFICACOES",
        appendActions: true,
        translateFn: (key) => this.$t(key),
      })
        .then((headers) => {
          this.headers = headers;
        })
        .catch((e) => {
          console.log("Response : " + e.message);
          if (e.message === "Request failed with status code 401") {
            EventBus.$emit("show-error", { error: e });
          }
        });
    },
    onEmpresaInput(id) {
      this.idEmpresaSelected = id;
      this.idLinhaSelected = null;
      this.idVeiculosSelected = [];
      if (this.$refs.linhaSelect && this.$refs.linhaSelect.resetData) {
        this.$refs.linhaSelect.resetData();
      }
      if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.setSelectedItems) {
        this.$refs.veiculosSelect.setSelectedItems([]);
      }
    },
    async exportPDF(div) {
      this.mensagemProgressoDialog = this.$t('operation.exportingPdfWait');
      this.progressoDialog = true;
      await domtoimage
        .toPng(div)
        .then(function (dataUrl) {
          var img = new Image(800, 400);
          img.src = dataUrl;
          const doc = new jsPDF({
            orientation: "l",
            //unit: "cm",
            //format: [300, 700],
            format: "a4",
          });
          doc.addImage(img, "JPEG", 5, 5, 285, 195);
          const date = new Date();
          const filename =
            "notificacao_" +
            date.getFullYear() +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            ("0" + date.getDate()).slice(-2) +
            ("0" + date.getHours()).slice(-2) +
            ("0" + date.getMinutes()).slice(-2) +
            ("0" + date.getSeconds()).slice(-2) +
            ".pdf";
          doc.save(filename);
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
      this.mensagemProgressoDialog = "";
      this.progressoDialog = false;
    },
    exportNotificacoesCsv() {
      if (this.filteredNotificacoes.length > 0) {
        this.mensagemProgressoDialog =
          this.$t('relNotification.exportToCsvWait');
        this.progressoDialog = true;
      }
    },
    sucessoExportCsv() {
      this.mensagemProgressoDialog = "";
      this.progressoDialog = false;
    },
    getConfig() {
      apiController.request(apiController.endpoints.getallConfig, {
        onSuccess: (response) => {
          this.config = response.data[0];
          this.limparFiltrosNotificacoes();
        },
      });
    },
    populaPosicoes() {
      let dataInicial = DateUtils.getDateSQLFormatted(new Date(this.dti));
      let dataFinal = DateUtils.getDateSQLFormatted(new Date(this.dtf));
      let temp = {
        id: this.idVeiculosSelected,
        dti: dataInicial,
        dtf: dataFinal
      };
      apiController.request(apiController.endpoints.getPosicoesporcarrodata, {
        data: temp,
        onSuccess: (response) => {
          this.posicoes = response.data;
        },
        onError: () => {
          this.loading = false;
        },
      });
    },
    populaTipoNotificacaoSelect() {
      apiController.request(apiController.endpoints.getallTiposnotificacoes, {
        onSuccess: (response) => {
          this.tipoNotificacaoSelect = response.data
            .filter((t) => t.show_relatorio === 1)
            .map((t) => ({
              ...t,
              descricao_tipo_notificacao: translateDbField(
                t.translation_key,
                t.descricao_tipo_notificacao
              )
            }));
        },
      });
    },
    populaNotificacoes() {
      var dti = DateUtils.getDateSQLFormatted(this.dti);
      var dtf = DateUtils.getDateSQLFormatted(this.dtf);
      if (dti > dtf) {
        this.mensagemAlertaErro =
          this.$t('datetime.startDateAfterEndDate');
        this.showAlertErroNotificacoes = true;
      } else {
        this.loading = true;
        var params = {
          dtinicio: dti,
          dtfim: dtf,
          idempresa: this.idEmpresaSelected,
          idlinha: this.idLinhaSelected,
          idveiculo: this.idVeiculosSelected,
          tiponotificacao: this.idTipoNotificacaoSelected,
          tratada: this.tratadaSelected,
          bilhetagemfora: this.bilhetagemForaAreaSelected,
        };
        apiController.request(apiController.endpoints.getNotificacoespordata, {
          data: params,
          onSuccess: (response) => {
            this.notificacoes = response.data.map((n) => ({
              ...n,
              descricao_tipo_notificacao: translateDbField(
                n.translation_key,
                n.descricao_tipo_notificacao
              )
            }));
            this.notificacoes = this.notificacoes.filter((n) => this.passaFiltroUnidades(n));
            this.filteredNotificacoes = this.notificacoes;
            this.loading = false;
          },
          onError: () => {
            this.loading = false;
          },
        });
      }
    },
    limparFiltrosNotificacoes() {
      [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
      this.idEmpresaSelected = null;
      this.idLinhaSelected = null;
      this.idVeiculosSelected = [];
      this.unidadesSelecionadas = [];
      this.filteredNotificacoes = [];
      this.notificacoes = [];
      this.search = "";
      this.showAlertErroNotificacoes = false;
      this.tipoAlertaNotificacoes = "error";
      this.mensagemAlertaSucessoNotificacao = "";
      this.showAlertSucessoNotificacoes = false;
      this.idTipoNotificacaoSelected = [];
      this.tipoNotificacaoSelect = [];
      this.tratadaSelected = null;
      this.bilhetagemForaAreaSelected = null;
      this.mensagemProgressoDialog = "";
      this.progressoDialog = false;
      if (this.$refs.empresaSelect && this.$refs.empresaSelect.resetData) {
        this.$refs.empresaSelect.resetData();
      }
      if (this.$refs.linhaSelect && this.$refs.linhaSelect.resetData) {
        this.$refs.linhaSelect.resetData();
      }
      if (this.$refs.veiculosSelect && this.$refs.veiculosSelect.resetData) {
        this.$refs.veiculosSelect.resetData();
      }
      if (this.$refs.unidadesSelect && this.$refs.unidadesSelect.resetData) {
        this.$refs.unidadesSelect.resetData();
      }
      this.populaTipoNotificacaoSelect();
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        silent: true,
        onSuccess: (response) => {
          this.setup = Object.assign({}, response.data[0]);
        },
        onError: (e) => {
          console.log("Response : " + e.message);
          if (e.message == "Request failed with status code 401") {
            EventBus.$emit('show-error', { error: e });
          }
        },
      });
    },
    showResetNotificacaoDialog(item) {
      if (item == null) {
        var dtinicio = null;
        var dtfim = null;
        if (typeof this.dti == "string") {
          dtinicio = this.dti;
        } else {
          dtinicio =
            this.dti.toLocaleString().substring(0, 10) +
            this.dti.toLocaleString().substring(11);
        }

        if (typeof this.dtf == "string") {
          dtfim = this.dtf;
        } else {
          dtfim = this.dtf.toLocaleString();
        }
        this.mensagemResetDialog =
          this.$t('relNotification.confirmResetPeriod', {dti: dtinicio, dtf: dtfim})
        this.idnotificacaoreset = null;
        this.confirmResetDialog = true;
      } else {
        this.mensagemResetDialog = this.$t('relNotification.confirmReset');
        this.idnotificacaoreset = item;
        this.confirmResetDialog = true;
      }
    },
    resetNotificacao() {
      this.confirmResetDialog = false;
      var endpoint = null;
      var params = null;
      if (this.idnotificacaoreset == null) {
        var dti = DateUtils.getDateSQLFormatted(this.dti);
        var dtf = DateUtils.getDateSQLFormatted(this.dtf);
        endpoint = apiController.endpoints.updateNotificacaoporperiodo;
        params = { dtinicio: dti, dtfim: dtf };
      } else {
        endpoint = apiController.endpoints.updateNotificacao;
        params = { id_notificacao: this.idnotificacaoreset.id_notificacao };
      }
      this.mensagemProgressoDialog = this.$t('relNotification.resettingNotificationWait');
      this.progressoDialog = true;
      apiController.request(endpoint, {
        data: params,
        onSuccess: () => {
          if (this.idnotificacaoreset == null) {
            this.mensagemAlertaSucessoNotificacao =
              this.$t('relNotification.successfullyResetNotf');
            this.showAlertSucessoNotificacoes = true;
          } else {
            this.populaNotificacoes();
          }
          this.mensagemProgressoDialog = "";
          this.progressoDialog = false;
        },
        onError: () => {
          this.mensagemProgressoDialog = "";
          this.progressoDialog = false;
        },
      });
    },
    showDialogMapaNotificacoes(item) {
      if (item.tem_endereco === this.$t('button.confirm')) {
        this.itemEndereco = [];
        this.itemEndereco = [
          {
            street: item.rua,
            houseNumber: item.numero,
            district: item.bairro,
            city: item.cidade,
            stateCode: item.uf,
            postalCode: item.cep,
          }];
        this.toogleBtnObterEndereco = true;
      } else {
        this.itemEndereco = [];
        this.itemEndereco = [
          {
            street: "",
            houseNumber: "",
            district: "",
            city: "",
            stateCode: "",
            postalCode: "",
          }];
        this.toogleBtnObterEndereco = false;
      }

      this.itemMapaNotificacao = [];
      this.itemMapaNotificacao.push(item);

      this.dtPosicaoNotificacao = item.dt_ultima_posicao;
      this.latNotificacao = item.lat;
      this.lngNotificacao = item.lng;

      var dti =
        item.dt_notificacao_extenso.substr(6, 4) +
        item.dt_notificacao_extenso.substr(3, 2) +
        item.dt_notificacao_extenso.substr(0, 2);

      if (item.tem_area == 1) {
        apiController.request(apiController.endpoints.getAreaporid, {
          params: { id: item.id_area },
          silent: true,
          onSuccess: (response) => {
            if (response.data.length > 0) {
              this.polygonNotificacoes.latlngs = this.parseShapeNotificacao(
                response.data[0].shape
              );
              const centro = Math.floor(
                this.polygonNotificacoes.latlngs.length / 2
              );
              this.currentCenter = [
                this.polygonNotificacoes.latlngs[centro].lat,
                this.polygonNotificacoes.latlngs[centro].lng];
              this.showPolygonNotificacao = true;
            }
          },
          onError: (e) => {
            console.log("Response : " + e.message);
            if (e.message == "Request failed with status code 401") {
              this.mensagemAutorizacaoDialog = e.response.data.mensagem;
              this.autorizacaoDialog = true;
            }
          },
        });

        this.idVeiculoNotificacao = item.id_veiculo;
        this.populaBilhetagensPorCarro(dti + "000000", dti + "235959");
      }

      if (item.tem_cerca == 1) {
        apiController.request(apiController.endpoints.getCercaporid, {
          params: { id: item.id_cerca },
          onSuccess: (response) => {
            if (response.data.length > 0) {
              this.polygonNotificacoes.latlngs = this.parseShapeNotificacao(
                response.data[0].shape
              );
              const centro = Math.floor(
                this.polygonNotificacoes.latlngs.length / 2
              );
              this.currentCenter = [
                this.polygonNotificacoes.latlngs[centro].lat,
                this.polygonNotificacoes.latlngs[centro].lng];
              this.showPolygonNotificacao = true;
            }
          },
        });
      }

      if (item.tem_linha == 1) {
        apiController.request(apiController.endpoints.getRotaporid, {
          params: { id: item.id_rota },
          onSuccess: (response) => {
            if (response.data.length > 0) {
              this.polylineNotificacoes.latlngs = this.parseShapeNotificacao(
                response.data[0].shape
              );
              const centro = Math.floor(
                this.polylineNotificacoes.latlngs.length / 2
              );
              this.currentCenter = [
                this.polylineNotificacoes.latlngs[centro].lat,
                this.polylineNotificacoes.latlngs[centro].lng];
              this.showPolylineNotificacao = true;
            }
          },
        });
      }

      if (item.id_tipo_notificacao == 13 || item.id_tipo_notificacao == 9) {
        this.dtPosicaoNotificacao = item.dt_ult_posicao_bilhetagem;
        this.latNotificacao = item.lat_bilhetagem;
        this.lngNotificacao = item.lng_bilhetagem;
      }

      if (item.gps_offline == 1) {
        this.dtPosicaoNotificacao = item.dt_ultima_posicao;
        this.latNotificacao = item.lat;
        this.lngNotificacao = item.lng;
      }
      this.key = this.key === 0 ? 1 : 0;
      this.dialogMapa = true;
    },
    parseShapeNotificacao(shape) {
      var coords = [];
      if (shape === null) { return coords; }
      const array = JSON.parse(shape);
      if (array.length > 0) {
        for (var i = 0; i < array.length; i++) {
          coords.push({ lng: array[i].lg, lat: array[i].lt });
        }
      }
      return coords;
    },
    populaBilhetagensPorCarro(dti, dtf) {
      let temp = {
        id: this.idVeiculoNotificacao,
        dti: dti,
        dtf: dtf
      }
      apiController.request(apiController.endpoints.getBilhetagensporcarrodata, {
        data: temp,
        onSuccess: (response) => {
          console.log(response.data);
          this.bilhetagens = [];
          if (response.data.length > 0) {
            this.bilhetagens = response.data;
            this.markerBilhetagensVisible = true;
          }
        },
      });
    },
    closeDialogMapaNotificacoes() {
      this.itemMapaNotificacao = [
        {
          id_notificacao: "",
          dt_notificacao: "",
          dt_notificacao_extenso: "",
          id_tipo_notificacao: "",
          descricao_tipo_notificacao: "",
          id_veiculo: "",
          nome_linha_veiculo: "",
          cod_veiculo: "",
          nome_permissionario: "",
          cod_equipamento: "",
          nome_area_veiculo: "",
          id_empresa: "",
          id_area: "",
          tem_area: "",
          nome_area: "",
          shape_area: "",
          id_cerca: "",
          tem_cerca: "",
          nome_cerca: "",
          shape_cerca: "",
          id_linha: "",
          tem_linha: "",
          nome_linha: "",
          velocidade_linha: "",
          shape_linha: "",
          lat: "",
          lng: "",
          rumo: "",
          velocidade: "",
          reset: "",
          reset_extenso: "",
        }];
      this.polygonNotificacoes.latlngs = [];
      this.polylineNotificacoes.latlngs = [];
      this.showPolygonNotificacao = false;
      this.showPolylineNotificacao = false;
      this.dialogMapa = false;
      //this.populaNotificacoes();
    },
  }
}
</script>
<style></style>